import { gql } from '__generated__';

export const SupportaCampaignFieldsFragment = gql(`
  fragment SupportaCampaignFields on SupportaCampaign {
    id
    title
    funds_raised
    url
    charity {
      id
      title
      logo_url
    }
  }
`);

export default gql(`
  query GetSupportaCampaigns($participant: ID!, $event: ID!, $token: String) {
    registrationSummary(participant: $participant, event: $event, token: $token) {
      id
      event_participant {
        id
        company_supporta_campaign {
          ...SupportaCampaignFields
        }
      }
      supporta_campaigns {
        ...SupportaCampaignFields
      }
    }
  }
`);
